module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_uncompleted-0294af44a6857c7fe373fe3307ad0cce.png";